import React from "react";
import { GoogleLogo } from "@phosphor-icons/react";
import { API_ORIGIN } from "../lib/api";

const PROVIDERS = [
  { id: "google", label: "Gmail", icon: GoogleLogo },
];

export default function OAuthButtons({ role = "customer", compact = false }) {
  const isAndroidWebView = typeof navigator !== "undefined" && navigator.userAgent.includes("NexoraCabAndroidWebView");
  if (isAndroidWebView) return null;

  const start = (provider) => {
    const backend = API_ORIGIN;
    if (!backend) return;
    window.location.href = `${backend}/api/auth/oauth/${provider}/start?role=${encodeURIComponent(role)}`;
  };

  return (
    <div className={compact ? "space-y-2" : "space-y-3"}>
      <div className="flex items-center gap-3 text-[10px] font-bold uppercase tracking-widest text-muted-foreground">
        <span className="h-px flex-1 bg-white/10" />
        Connexion directe
        <span className="h-px flex-1 bg-white/10" />
      </div>
      <div className="grid grid-cols-1 gap-2">
        {PROVIDERS.map((provider) => (
          <button
            key={provider.id}
            type="button"
            onClick={() => start(provider.id)}
            className="flex min-h-12 min-w-0 items-center justify-center gap-1.5 rounded-2xl border border-white/10 bg-white/5 px-2 text-xs font-black text-foreground press-down hover:bg-white/10"
            data-testid={`oauth-${provider.id}`}
          >
            <provider.icon size={18} weight="bold" />
            <span className="truncate">{provider.label}</span>
          </button>
        ))}
      </div>
      <div className="text-center text-[10px] leading-4 text-muted-foreground">
        Gmail redirige vers la page officielle Google. La clé OAuth Google doit être configurée côté serveur.
      </div>
    </div>
  );
}
